import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import styles from "./Input.module.scss";
import { testIds } from "../../../common/testData";

const InputComponent = (props) => {
  const {
    input,
    meta,
    isDisable,
    isBigCheckedIcon,
    iconLeft,
    iconRight,
    onClick,
    className = "",
    required,
    variant,
    handleRightIconClick = () => {},
    ...otherProps
  } = props;
  const [selectionStart, setSelectionStart] = useState();
  const [selectionEnd, setSelectionEnd] = useState();
  const inputField = useRef();

  const handleOnChange = (ev) => {
    ev.persist();
    const { selectionStart, selectionEnd } = ev.target;
    setSelectionStart(selectionStart);
    setSelectionEnd(selectionEnd);
    if (props.upperCase) ev.target.value = ev.target.value.toUpperCase();
    input && input.onChange(ev);
    props.onChange && props.onChange(ev);
  };

  useEffect(() => {
    if (props.value && props.updateCursor) {
      inputField.current.selectionStart =
        props.value[props.value.length - 2] === "-"
          ? selectionStart + 1
          : selectionStart;
      inputField.current.selectionEnd =
        props.value[props.value.length - 2] === "-"
          ? selectionEnd + 1
          : selectionEnd;
    }
    // eslint-disable-next-line
  }, [props.value]);

  return (
    <fieldset className={`${styles["fieldset"]} ${styles[variant]}`}>
      <div
        className={`input-container ${styles[variant]} ${className} ${
          isDisable && styles.disabled
        } ${props.upperCase && styles.upperCase}`}
        onClick={onClick}
        data-testid={testIds["input-container"]}
      >
        {iconLeft && (
          <img className={styles.leftIcon} src={iconLeft} alt="" height="22" />
        )}
        <input
          ref={inputField}
          {...otherProps}
          type={props.type || "text"}
          name={props.name}
          disabled={isDisable}
          value={props.value}
          maxLength={props.maxLength}
          data-testid={testIds["input-component"]}
          {...input}
          onChange={(ev) => handleOnChange(ev)}
          required={true} // This does not have any impact just required for material behaviour
          className="input"
        />
        {iconRight && (
          <img
            onClick={() => handleRightIconClick(props.name)}
            className={styles.rightIcon}
            src={iconRight}
            alt=""
          />
        )}
        <label
          className="input-label"
          style={{ ...(iconLeft && { left: 40 }) }}
        >
          {props.label}
          {required && " * "}
        </label>
        {props.loading && <div className={styles["smallLoader"]} />}
        <div className={styles["bar"]} />
      </div>
      {meta && meta.error && meta.touched && (
        <span className={styles["input-error-msg"]}>{meta.error}</span>
      )}
      {isBigCheckedIcon && (
        <div className={styles["input_big_checked_icon"]}></div>
      )}
    </fieldset>
  );
};
export default InputComponent;

InputComponent.propTypes = {
  input: PropTypes.object,
  meta: PropTypes.object,
  isDisable: PropTypes.bool,
  isBigCheckedIcon: PropTypes.bool,
  name: PropTypes.string,
  value: PropTypes.string,
  maxLength: PropTypes.number,
  onChange: PropTypes.func,
  label: PropTypes.string,
  loading: PropTypes.bool,
  type: PropTypes.string,
};
